// extracted by mini-css-extract-plugin
module.exports = {"loyaltyHeader":"_9dbxV","loyaltyHeader-image":"_8i4Y3","loyaltyHeader-description":"aaVk6","loyaltyHeader-description-text":"AXbgg"};